export default __webpack_public_path__ + "static/media/white-poly.4f238b4b.jpg";